import React, { FunctionComponent, memo, useEffect } from 'react';

import useFakeProgress from '../../../hooks/useFakeProgress';
import ProgressBar from '../progress-bar';

interface IProps {
  isDoneUploading: boolean;
}

const RowProgress: FunctionComponent<IProps> = ({ isDoneUploading }) => {
  const { status, finish, start } = useFakeProgress(500);

  useEffect(() => {
    if (isDoneUploading) {
      finish();
    }
  }, [finish, isDoneUploading]);

  useEffect(() => {
    start();
  }, [start]);

  return (
    <ProgressBar
      className="absolute bottom-0 left-0 right-0 z-60"
      status={status}
    />
  );
};

export default memo(RowProgress);
